/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Page_TitleInputs */



/**
* | output |
* | --- |
* | "Help & Documentation" |
*
* @param {Help_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_page_title = /** @type {((inputs?: Help_Page_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Page_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aide et documentation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ayuda y documentación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ajuda e documentação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida e documentazione")
	return /** @type {LocalizedString} */ ("Help & Documentation")
});